var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardListStatusIcon1 = function SvgNewcsDashboardListStatusIcon1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_list_status_icon1_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M260 434h14v14h-14z",
    "data-name": "\\u77E9\\u5F62 334"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_list_status_icon1_svg__a)",
    transform: "translate(-260 -434)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3fb3ff",
    d: "M259.997 441a7 7 0 0 1 7-7 7 7 0 0 1 7 7 7 7 0 0 1-7 7 7 7 0 0 1-7-7m1.25 0a5.757 5.757 0 0 0 5.75 5.75 5.757 5.757 0 0 0 5.75-5.75 5.757 5.757 0 0 0-5.75-5.75 5.757 5.757 0 0 0-5.75 5.75m8 0a1 1 0 0 1 1-1 1 1 0 0 1 1 1 1 1 0 0 1-1 1 1 1 0 0 1-1.001-1Zm-3.25 0a1 1 0 0 1 1-1 1 1 0 0 1 1 1 1 1 0 0 1-1 1 1 1 0 0 1-1-1m-3.249 0a1 1 0 0 1 1-1 1 1 0 0 1 1 1 1 1 0 0 1-1 1 1 1 0 0 1-1.001-1Z",
    "data-name": 0
  }))));
};
export default SvgNewcsDashboardListStatusIcon1;